import {
  getSurveyMessages,
  postSurveyMessage
} from '../api';

export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';
export const ADD_INFO_MESSAGE = 'ADD_INFO_MESSAGE';
export const ADD_SURVEY_MESSAGE = 'ADD_SURVEY_MESSAGE';
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const GET_SURVEY_MESSAGES = 'GET_SURVEY_MESSAGES';
export const GET_SURVEY_MESSAGES_FULFILLED = 'GET_SURVEY_MESSAGES_FULFILLED';

export const addErrorMessageAction = (error) => ({
  type: ADD_ERROR_MESSAGE,
  payload: error
});

export const addInfoMessageAction = (info) => ({
  type: ADD_INFO_MESSAGE,
  payload: info
});

export const updateSurveyMessageAction = (surveyId, data) => ({
  type: ADD_SURVEY_MESSAGE,
  payload: postSurveyMessage(surveyId, data)
});

export const closeMessageAction = (id) => ({
  type: CLOSE_MESSAGE,
  payload: id
});

export const clearMessagesAction = () => ({
  type: CLEAR_MESSAGES
});

export const getSurveyMessagesAction = (surveyId) => ({
  type: GET_SURVEY_MESSAGES,
  payload: getSurveyMessages(surveyId)
});
